import { render, staticRenderFns } from "./ProposalTable.vue?vue&type=template&id=6d56b884&scoped=true"
import script from "./ProposalTable.vue?vue&type=script&lang=js"
export * from "./ProposalTable.vue?vue&type=script&lang=js"
import style0 from "./ProposalTable.vue?vue&type=style&index=0&id=6d56b884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56b884",
  null
  
)

export default component.exports